/* eslint-disable camelcase */
import {
  Button, Popover
    } from '@nike/eds';
import PropTypes from 'prop-types';
import { translate } from 'rcffus-sps-translations';
import React from 'react';
import { useSelector } from 'react-redux';

import { getBodyTranslations } from '../../redux/selectors';

import { PrintIcon } from './Npos/reusable/icons';

const PrintReceiptInfo = ({
 children, showInfo, setShowInfo, reprintAvailability
}) => {
  const { RL_Ok } = useSelector(getBodyTranslations);
  const { locale: { storeLocale } } = useSelector((state) => state);
  const { isReprintAvailable, message } = reprintAvailability;

  return (!isReprintAvailable
     ? (
       <Popover
         bodySlot={(
           <>
             <PrintIcon size="l" />
             <p className="eds-type--body-3" style={{ width: '256px' }}>
               {translate(message, storeLocale) || message}
             </p>
           </>
          )}
         className="popover-info"
         footerSlot={<Button size="small" onClick={() => setShowInfo(false)}>{RL_Ok}</Button>}
         isOpen={showInfo}
         placement="top"
         onClickOutside={() => setShowInfo(false)}
       >
         {children}
       </Popover>
    )
    : <>{children}</>);
};

PrintReceiptInfo.propTypes = {
  children: PropTypes.node.isRequired,
  reprintAvailability: PropTypes.shape({
    isReprintAvailable: PropTypes.bool.isRequired,
    message: PropTypes.string,
  }).isRequired,
  setShowInfo: PropTypes.func.isRequired,
  showInfo: PropTypes.bool.isRequired,
};

export default PrintReceiptInfo;
